export const SCANNED = 'SCANNED';
export const ADD_SCANNED = 'ADD_SCANNED';
export const CONNECTED = 'CONNECTED';
export const TERMINAL_DATA = 'TERMINAL_DATA';
export const CLEAR_TERMINAL_DATA = 'CLEAR_TERMINAL_DATA';
export const TAB = 'TAB';
export const IS_ENABLE_BT_TAB = 'IS_ENABLE_BT_TAB';
export const IS_ENABLE_USB_TAB = 'IS_ENABLE_USB_TAB';
export const IS_ENABLE_UPDATE_OS = 'IS_ENABLE_UPDATE_OS';



// WEBPACK FOOTER //
// ./src/store/modules/device/mutation-types.js